import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { RewardItemValidationSchema } from "../schemas/create.schema";
import { unFormatCurrency } from "@/common/utils/unFormatters";
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { RewardItemData } from "@/common/types/rewardItems";
import { mapToDeletion } from "@/common/utils/railsHelpers";

interface UseUpdateRewardItemProps {
  id: string
  initialRewardItem?: RewardItemData
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateRewardItem = ({id, initialRewardItem, onSuccess, onError}: UseUpdateRewardItemProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateRewardItem'],
    mutationFn: async (form: RewardItemValidationSchema) => {
      const payload = {
        ...form,
        reference_price: form?.reference_price ? unFormatCurrency(form.reference_price) : undefined,
        points_to_redeem: form?.points_to_redeem ? Number(form.points_to_redeem.replace(/\D/g, '')) : undefined,
        product_badges_attributes: getRailsUpdate(
          initialRewardItem?.product_badges || [],
          form.product_badges_attributes || [],
          ({badge}) => badge.id,
          ({value}) => value || '',
          mapToDeletion,
          ({value}) => ({ badge_id: value })
        ),
        pictures_attachments_attributes: getRailsUpdate(
          initialRewardItem?.pictures || [],
          form.pictures_attachments_attributes || [], 
          (photo) => photo.id, 
          (photo) => photo.id, 
          (photo) => ({ id: photo.id, _destroy: true }), 
          (photo) => ({ blob_id: photo.id })
        ),
      }

      return privateAxios.put(`/tmais/products/${id}`, { product: payload })
    },
    onSuccess,
    onError
  });
}

export default useUpdateRewardItem
